import "./BiomarkersAddComponent.scss";
import {ITimelineItem} from "../../../shared/models/timeline.model";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import TimelineComponent from "../../../shared/components/timeline/timelineComponent";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../constants";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import BiomarkersBasicDetailsAddComponent from "./biomarkers-basic-details-add/BiomarkersBasicDetailsAddComponent";
import BiomarkersReportConfigAddComponent from "./biomarkers-report-config-add/BiomarkersReportConfigAddComponent";
// import BiomarkersAttachmentsAddComponent from "./biomarkers-attachments-add/BiomarkersAttachmentsAddComponent";

interface BiomarkersAddComponentProps {

}

const BASIC_DETAILS = 'basic-details';
const REPORT_CONFIGURATION = 'report-configuration';
// const ATTACHMENTS = 'attachments';

const STEPS: ITimelineItem[] = [
    {
        id: BASIC_DETAILS,
        title: "Basic Details",
    },
    {
        id: REPORT_CONFIGURATION,
        title: "Report Configuration",
    },
    // {
    //     id: ATTACHMENTS,
    //     title: "Attachments",
    // },
];
const BiomarkersAddComponent = (props: BiomarkersAddComponentProps) => {

    const [steps] = useState<ITimelineItem[]>([..._.cloneDeep(STEPS)]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentStep, setCurrentStep] = useState<ITimelineItem | undefined>(STEPS[0]);
    const [activeStep, setActiveStep] = React.useState(0);
    const [biomarkerId, setBiomarkerId] = useState<number | undefined>(undefined);
    const [bioMarkerConfigration, setBioMarkerConfigration] = useState<any>(undefined);
    const [biomarkerDetails, setBiomarkerDetails] = useState<any>(undefined);
    const [isBiomarkerDetailsLoading, setIsBiomarkerDetailsLoading] = useState<boolean>(false);
    const [configList, setConfigList] = React.useState<any[]>([]);
    const [isConfigListLoading, setIsConfigListLoading] = React.useState<boolean>(false);

    const navigate = useNavigate();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentNavParams("", "Biomarkers"));
        dispatch(setSideMenuView('compact'));

    }, [dispatch]);

    const updateSteps = useCallback((currentStepIndex: number) => {
        setCurrentStep(STEPS[currentStepIndex]);
        searchParams.set("step", STEPS[currentStepIndex].id);
        setSearchParams(searchParams);
        setActiveStep(currentStepIndex);
    }, [searchParams, setSearchParams]);

    const handleADDSuccess = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Congratulations! ',
            confirmationSubTitle: 'Biomarker has been successfully created.',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            hideNoOption: true,
            yes: {
                text: "Proceed",
                color: "primary"
            }

        }).then(() => {
            navigate(CommonService._routeConfig.BiomarkerListRoute());
        })
            .catch(() => {
            });
    }, [navigate]);


    const getBiomarkerDetails = useCallback((biomarkerId: any) => {
        const payload = {};
        let biomarkerDetails: any = {};
        setIsBiomarkerDetailsLoading(true);
        CommonService._biomarker.getBiomarkerDetails(biomarkerId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    biomarkerDetails = response.data;
                }
                setBioMarkerConfigration(biomarkerDetails?.reportFormat)
                setBiomarkerDetails(biomarkerDetails);
                setIsBiomarkerDetailsLoading(false);
            })
            .catch((error: any) => {
                // setBiomarkerDetails(biomarkerDetails);
                setIsBiomarkerDetailsLoading(false);
            });
    }, []);

    const getConfigurationList = useCallback((biomarkerId: any) => {
        setIsConfigListLoading(true);
        CommonService._biomarker.getBiomarkerConfigurations(biomarkerId, {})
            .then((response: IAPIResponseType<any>) => {
                setIsConfigListLoading(false);
                setConfigList(response?.data || []);
            })
            .catch((error: any) => {
                setIsConfigListLoading(false);
            });
    }, []);


    useEffect(() => {
        if (biomarkerId) {
            getBiomarkerDetails(biomarkerId);
            getConfigurationList(biomarkerId);
        }
    }, [biomarkerId, getBiomarkerDetails, getConfigurationList]);

    const handleBiomarkerCancel = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Please confirm!',
            confirmationSubTitle: 'Are you sure you want to exit without adding this biomarker?',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: "Exit",
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "primary"
            }
        }).then(() => {
            navigate(CommonService._routeConfig.BiomarkerListRoute());
        }).catch(() => {
            // do nothing;
        });
    }, [navigate]);

    const handleNext = useCallback((currentStepIndex: number, currentStepId: string, biomarkerId?: number, data?: any) => {
        if (parseInt(searchParams.get("lastCompletedStep") || "1") <= currentStepIndex) {
            searchParams.set("lastCompletedStep", currentStepIndex.toString());
            setSearchParams(searchParams);
        }
        switch (currentStepId) {
            case BASIC_DETAILS :
                if (biomarkerId) {
                    setBiomarkerId(biomarkerId);
                    setBioMarkerConfigration(data?.reportFormat)
                    searchParams.set("biomarkerId", biomarkerId.toString());
                    setSearchParams(searchParams);
                }
                if (data) {
                    setBiomarkerId(data);
                }
                updateSteps(currentStepIndex);
                break;
            case REPORT_CONFIGURATION :
                if (data) {
                    setConfigList(data);
                }
                updateSteps(currentStepIndex);
                break;
            default:
                <></>
        }
    }, [searchParams, setSearchParams, updateSteps]);

    useEffect(() => {
        const step = searchParams.get("step");
        setActiveStep(STEPS.findIndex((stepItem: any) => stepItem.id === step));
        const locationId = searchParams.get("biomarkerId");
        const stepIDS = STEPS.map(item => item.id);
        let stepIndex = 0;
        if (locationId) {
            setBiomarkerId(parseInt(locationId, 10));
            if (stepIDS.indexOf(step) > -1) {
                stepIndex = stepIDS.indexOf(step);
            } else {
                stepIndex = 1;
            }
        } else {
            stepIndex = 0;
            setActiveStep(0)
        }
        setCurrentStep(STEPS[stepIndex]);
    }, [searchParams]);

    const handlePrevious = useCallback((currentStepIndex: number, currentStepId: string) => {
        updateSteps(currentStepIndex);
    }, [updateSteps]);

    const renderComponent = useCallback(() => {
        if (!biomarkerId) {
            if (currentStep?.id === BASIC_DETAILS) {
                return <BiomarkersBasicDetailsAddComponent
                    biomarkerDetails={biomarkerDetails}
                    biomarkerId={biomarkerId}
                    next={(biomarkerId: number, details: any) => handleNext(1, BASIC_DETAILS, biomarkerId, details)}
                    cancel={handleBiomarkerCancel}
                />
            }
        } else {
            switch (currentStep && currentStep.id) {
                case BASIC_DETAILS:
                    return <BiomarkersBasicDetailsAddComponent
                        biomarkerDetails={biomarkerDetails}
                        biomarkerId={biomarkerId}
                        next={(biomarkerId: number, data: any) => handleNext(1, BASIC_DETAILS, biomarkerId, data)}
                        cancel={handleBiomarkerCancel}
                    />
                case REPORT_CONFIGURATION:
                    return <BiomarkersReportConfigAddComponent
                        biomarkerReportFormat={bioMarkerConfigration}
                        biomarkerDetails={biomarkerDetails}
                        configList={configList}
                        biomarkerId={biomarkerId}
                        // next={(configList: any) => handleNext(2, REPORT_CONFIGURATION, biomarkerId,configList)}
                        next={handleADDSuccess}
                        cancel={handleBiomarkerCancel}
                        prev={() => handlePrevious(0, BASIC_DETAILS)}
                    />
                // case ATTACHMENTS:
                //     return <BiomarkersAttachmentsAddComponent
                //         biomarkerId={biomarkerId}
                //         next={() => handleADDSuccess()}
                //         cancel={handleBiomarkerCancel}
                //         prev={() => handlePrevious(1, REPORT_CONFIGURATION)}
                //     />
                default:
                    <></>
            }
        }
    }, [biomarkerId, biomarkerDetails, currentStep, handleNext, handleBiomarkerCancel, handlePrevious, bioMarkerConfigration, handleADDSuccess, configList]);


    const handleStepClick = useCallback((step: any) => {
        const lastCompletedStep = parseInt(searchParams.get("lastCompletedStep") || '0');
        const clickedStepIndex = STEPS.findIndex((stepItem: any) => stepItem.id === step.id);
        if (clickedStepIndex <= (lastCompletedStep)) {
            setActiveStep(clickedStepIndex);
            setCurrentStep(step);
            searchParams.set("step", step.id);
            setSearchParams(searchParams);
        }
    }, [searchParams, setSearchParams]);

    return (
        <div className={'biomarkers-add-component screen add-layout-with-timeline'}>
            <Grid container spacing={2} className="add-form-timeline-wrapper">
                <Grid item sm={12} md={3} xl={3} className="timeline-layout"
                      sx={{
                          display: {xs: "none", md: "block"}
                      }}>
                    <div className="add-layout-title">Adding Biomarker</div>
                    <div className="add-layout-timeline">
                        <TimelineComponent
                            activeStep={activeStep}
                            steps={steps}
                            handleStepClick={handleStepClick}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={9} xl={9} className="add-form-content">
                    <div className="add-layout-form-content">
                        {renderComponent()}
                    </div>
                </Grid>
            </Grid>
            {(isBiomarkerDetailsLoading || isConfigListLoading) &&
                <div className={"glass-effect h-v-center flex-direction-column"}>
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
        </div>
    );

};

export default BiomarkersAddComponent;
